var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.pageTitle}},[_c('Styles',{attrs:{"items":_vm.styleList,"loadMore":_vm.loadMore},on:{"on-click":_vm.chooseStyle,"on-change":_vm.changeStyle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }